import gettext from '@sdk/lang/gettext';
import { BreakCategory } from '@sdk/settings/types';
import {
  AutomatedBreaksApiFields,
  AutomatedBreaksWaivingBreakMode,
  AutomatedBreaksWaivingMode,
} from '@sdk/authentication/types/apiTypes';

import { AllowedBreaksErrors } from '@web/settings/components/schedule/Breaks/breaks.types';

export const BREAK_AUTOMATION_OPTIONS = [
  { value: 0, label: gettext('Standard') },
  { value: 1, label: gettext('Automated') },
];

export const BREAK_CATEGORY_OPTIONS = [
  { value: BreakCategory.unpaid, label: gettext('Unpaid') },
  { value: BreakCategory.paid, label: gettext('Paid') },
];

export const AUTOMATED_BREAK_CATEGORY_OPTIONS = [
  { value: BreakCategory.unpaid, label: gettext('Unpaid') },
  { value: BreakCategory.paid, label: gettext('Paid') },
];

export const BREAK_DURATION_OPTIONS = [
  { value: 0, label: 'None' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
];

export const AUTOMATED_BREAKS_WAIVING_MODE_OPTIONS = [
  { value: AutomatedBreaksWaivingMode.FIRST_BREAK_ONLY, label: gettext('1st break only') },
  { value: AutomatedBreaksWaivingMode.SECOND_BREAK_ONLY, label: gettext('2nd break only') },
  {
    value: AutomatedBreaksWaivingMode.FIRST_AND_SECOND_BREAK,
    label: gettext('1st and 2nd break'),
  },
];

export const AUTOMATED_BREAKS_WAIVING_BREAK_OPTIONS = [
  { value: AutomatedBreaksWaivingBreakMode.ALWAYS, label: gettext('always') },
  {
    value: AutomatedBreaksWaivingBreakMode.IF_EMPLOYEE_WORKS_LESS_THAN_HOURS,
    label: gettext('when'),
  },
];

export const BREAKS_VALIDATION_FIELD_NAMES: AllowedBreaksErrors[] = [
  AutomatedBreaksApiFields.automatedBreaksMealBreakThreshold,
  AutomatedBreaksApiFields.automatedBreaksMealBreakDuration,
  AutomatedBreaksApiFields.automatedBreaksRestBreakDuration,
  AutomatedBreaksApiFields.automatedBreaksRestBreakThreshold,
  AutomatedBreaksApiFields.automatedBreaksIsEnabled,
];
